import { render } from "./game-search-modal.vue?vue&type=template&id=50576464&scoped=true"
import script from "./game-search-modal.vue?vue&type=script&lang=js"
export * from "./game-search-modal.vue?vue&type=script&lang=js"

import "./game-search-modal.vue?vue&type=style&index=0&id=50576464&scoped=true&lang=css"

import exportComponent from "/tmp/build_ed238492/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50576464"]])

export default __exports__